import { useEffect, useCallback } from "react"

const DOMAIN = "Receipts"
const SUBDOMAIN = "OptOut"
const PAGE = "OptOutDigitalReceipts"

export const useOptOutTracking = (receiptUUID: string | undefined) => {
  useEffect(() => {
    if (receiptUUID) {
      window.izPushEvent(DOMAIN, SUBDOMAIN, PAGE, "Viewed", { receiptUUID })
    }
  }, [receiptUUID])

  const optOutEventListener = useCallback(() => {
    if (receiptUUID) {
      window.izPushEvent(DOMAIN, SUBDOMAIN, PAGE, "ClickedRemoveContactInfo", {
        receiptUUID,
      })
    }
  }, [receiptUUID])

  useEffect(() => {
    const optOutButton = document.querySelector('[data-track-id="opt-out-button"]')
    if (!optOutButton) {
      return
    }
    optOutButton.addEventListener("click", optOutEventListener)
    return () => optOutButton.removeEventListener("click", optOutEventListener)
  }, [optOutEventListener])
}

export const useOptOutStatusTracking = (
  receiptUUID: string | undefined,
  status: string,
) => {
  useEffect(() => {
    if (receiptUUID) {
      window.izPushEvent(DOMAIN, SUBDOMAIN, PAGE, "RemovedContactInfo", { receiptUUID })
    }
  }, [receiptUUID, status])
}
